import React, { useState, useEffect } from 'react';

// Manual text input for dates in dd/mm/yyyy format.
// Emits ISO strings ("YYYY-MM-DD") to keep backend payloads compatible.
//
// Usage:
//   <DateInput value={form.joinDate} onChange={v => setForm({ ...form, joinDate: v })} />

const pad2 = (n) => String(n).padStart(2, '0');

const isoToDmy = (iso) => {
  if (!iso) return '';
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split('-');
  if (!y || !m || !d) return '';
  return `${d}/${m}/${y}`;
};

const dmyToIso = (txt) => {
  if (!txt) return '';
  const m = String(txt).trim().match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
  if (!m) return '';
  const d = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const y = parseInt(m[3], 10);
  if (mo < 1 || mo > 12) return '';
  const maxD = new Date(y, mo, 0).getDate();
  if (d < 1 || d > maxD) return '';
  return `${y}-${pad2(mo)}-${pad2(d)}`;
};

const DateInput = ({ value, onChange, required = false, className = '', placeholder = 'dd/mm/yyyy', ...rest }) => {
  const [text, setText] = useState(isoToDmy(value));
  const [err, setErr] = useState(false);

  useEffect(() => {
    const incoming = isoToDmy(value);
    if (incoming && incoming !== text) setText(incoming);
    if (!value && text && dmyToIso(text)) setText('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const commit = (raw) => {
    if (!raw.trim()) { setErr(false); onChange(''); return; }
    const iso = dmyToIso(raw);
    if (iso) { setErr(false); onChange(iso); }
    else { setErr(true); onChange(''); }
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={text}
      placeholder={placeholder}
      required={required}
      className={className}
      onChange={(e) => {
        let v = e.target.value.replace(/[^\d\/]/g, '');
        if (/^\d{3,}$/.test(v)) v = v.slice(0, 2) + '/' + v.slice(2);
        if (/^\d{2}\/\d{3,}$/.test(v)) v = v.slice(0, 5) + '/' + v.slice(5);
        v = v.slice(0, 10);
        setText(v);
        if (v === '' || /^\d{2}\/\d{2}\/\d{4}$/.test(v)) commit(v);
      }}
      onBlur={() => commit(text)}
      style={err ? { borderColor: '#ef4444' } : undefined}
      {...rest}
    />
  );
};

export default DateInput;
